module.exports = __webpack_public_path__ + "img/signup.6dfd9abe.jpg";